import { Linkedin, Mail } from "lucide-react";
import { ASSETS } from "@/lib/assets";

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer
      data-testid="site-footer"
      className="bg-[#0A0A0A] border-t border-[#2A2A2A]"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-16 pt-20 md:pt-28 pb-10">
        <div className="reveal">
          <div className="flex items-center gap-4 md:gap-6 mb-4">
            <img
              src={ASSETS.logoMonogram}
              alt="Becoming H.E.R."
              className="h-16 md:h-20 lg:h-24 w-auto rounded-sm border border-[#C9A66B]/30"
            />
            <div>
              <h3 className="font-serif text-4xl md:text-6xl lg:text-7xl leading-[0.9] tracking-tight text-[#EDEDED] font-light">
                Becoming{" "}
                <em
                  style={{
                    background:
                      "linear-gradient(135deg, #E9CE94 0%, #C9A66B 50%, #8A7040 100%)",
                    WebkitBackgroundClip: "text",
                    WebkitTextFillColor: "transparent",
                    backgroundClip: "text",
                  }}
                >
                  H.E.R.
                </em>
              </h3>
              <div className="mt-2 flex items-center gap-3">
                <span className="block w-8 h-px bg-[#C9A66B]" />
                <span className="text-[10px] md:text-[11px] tracking-[0.32em] uppercase text-[#A0A0A0]">
                  Honor · Excellence · Resilience
                </span>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-16 grid grid-cols-2 md:grid-cols-4 gap-10 border-t border-[#2A2A2A] pt-10">
          <div>
            <div className="text-[10px] tracking-[0.3em] uppercase text-[#A0A0A0] mb-4">
              The Firm
            </div>
            <ul className="space-y-2 text-[#EDEDED] font-serif italic text-lg">
              <li>
                <a href="#about" className="hover-underline">
                  About
                </a>
              </li>
              <li>
                <a href="#pillars" className="hover-underline">
                  Four Pillars
                </a>
              </li>
              <li>
                <a href="#services" className="hover-underline">
                  Services
                </a>
              </li>
            </ul>
          </div>
          <div>
            <div className="text-[10px] tracking-[0.3em] uppercase text-[#A0A0A0] mb-4">
              Services
            </div>
            <ul className="space-y-2 text-[#EDEDED] font-serif italic text-lg">
              <li>
                <a href="#services" className="hover-underline">
                  HR Consulting
                </a>
              </li>
              <li>
                <a href="#services" className="hover-underline">
                  Strategic Consulting
                </a>
              </li>
              <li>
                <a href="#services" className="hover-underline">
                  Leadership Development
                </a>
              </li>
              <li>
                <a href="#services" className="hover-underline">
                  Procurement &amp; Acquisition
                </a>
              </li>
            </ul>
          </div>
          <div>
            <div className="text-[10px] tracking-[0.3em] uppercase text-[#A0A0A0] mb-4">
              Contact
            </div>
            <ul className="space-y-2 text-[#EDEDED] text-[13px] font-light whitespace-nowrap">
              <li>
                <a
                  href="mailto:t.t.becomingh.e.r@gmail.com"
                  className="hover-underline"
                  data-testid="footer-email"
                >
                  t.t.becomingh.e.r@gmail.com
                </a>
              </li>
            </ul>
          </div>
          <div>
            <div className="text-[10px] tracking-[0.3em] uppercase text-[#A0A0A0] mb-4">
              Follow
            </div>
            <div className="flex items-center gap-4">
              <a
                href="#"
                aria-label="LinkedIn"
                data-testid="footer-linkedin"
                className="text-[#EDEDED] hover:text-[#6B6B6B] transition-colors"
              >
                <Linkedin size={20} />
              </a>
              <a
                href="mailto:t.t.becomingh.e.r@gmail.com"
                aria-label="Email"
                data-testid="footer-mail"
                className="text-[#EDEDED] hover:text-[#6B6B6B] transition-colors"
              >
                <Mail size={20} />
              </a>
            </div>
          </div>
        </div>

        <div className="mt-16 pt-6 border-t border-[#2A2A2A] flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
          <p className="text-[11px] tracking-[0.24em] uppercase text-[#A0A0A0]">
            © {year} Becoming H.E.R. LLC — All rights reserved.
          </p>
          <p className="text-[11px] tracking-[0.24em] uppercase text-[#A0A0A0]">
            Strategy · Solutions · Leadership · Growth
          </p>
        </div>
      </div>
    </footer>
  );
}
